import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Container from './Container';
import Authentication from './Authentication';
import { useApp } from '../context/AppContext';
import Login from '../modules/Auth/Login';
import Sidebar from '../modules/FindMeetings/Sidebar';
import { useState, useEffect } from 'react';
import { Dialog, DialogContent, Typography, Button } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import NovoAceiteDePoliticas from './NovoAceiteDePoliticas';

export const ProtectedLayout = () => {
    const { logged, loading, user } = useAuth();
    const location = useLocation();
    const [showApprovalModal, setShowApprovalModal] = useState(false);

    useEffect(() => {
        if (!user?.profile) return;
        const notifiedKey = `approval_notified_${user.id}`;
        const pendingKey = `approval_pending_${user.id}`;

        if (!user.profile.approved) {
            // Marca que o usuario tem aprovacao pendente
            localStorage.setItem(pendingKey, 'true');
        } else if (user.profile.approved) {
            // Se foi aprovado e tinha pendencia, mostra modal uma unica vez
            if (localStorage.getItem(pendingKey) && !localStorage.getItem(notifiedKey)) {
                localStorage.setItem(notifiedKey, 'true');
                setShowApprovalModal(true);
            }
        }
    }, [user?.profile?.approved]);

    if(loading) return <></>

    if (!logged) {
        // Salva a URL atual antes de mostrar o login
        const currentPath = location.pathname + location.search;
        sessionStorage.setItem('redirectAfterLogin', currentPath);
        return <Login />;
    }

    return (
        <Container>
            <Sidebar />
            <Outlet />
            {/* Aparece por cima de qualquer tela de quem esta logado: o aceite
                pendente vale para a conta, e nao para uma pagina especifica.
                Quem nao deve nada nao ve nada. */}
            <NovoAceiteDePoliticas />
            <Dialog
                open={showApprovalModal}
                onClose={() => setShowApprovalModal(false)}
                PaperProps={{ sx: { borderRadius: '16px', maxWidth: 420 } }}
            >
                <DialogContent sx={{ textAlign: 'center', p: { xs: 3, sm: 4 } }}>
                    <CheckCircleOutlineIcon sx={{ fontSize: 64, color: '#2e7d32', mb: 2 }} />
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        Seu cadastro de anfitrião foi aprovado!
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3, lineHeight: 1.6 }}>
                        Parabéns! Agora seus encontros estão visíveis para todos os usuários
                        e você pode receber convivas. Bons encontros!
                    </Typography>
                    <Button
                        variant="contained"
                        fullWidth
                        onClick={() => setShowApprovalModal(false)}
                        sx={{
                            bgcolor: '#006a61',
                            borderRadius: '8px',
                            height: 44,
                            textTransform: 'none',
                            fontWeight: 600,
                            '&:hover': { bgcolor: '#005a52' },
                        }}
                    >
                        Entendi
                    </Button>
                </DialogContent>
            </Dialog>
        </Container>
    );
};
